export default __webpack_public_path__ + "261438045174688df3575551c7e80e6a.png";